// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dragonite: PokeData = {
  "id": 149,
  "name": "dragonite",
  "height": 22,
  "weight": 2100,
  "base_experience": 270,
  "types": [
    PokeType.DRAGON,
    PokeType.FLYING
  ],
  "api_moves": [
    "fire-punch",
    "thunder-punch",
    "wing-attack",
    "slam",
    "wrap",
    "leer",
    "mist",
    "hyper-beam",
    "dragon-rage",
    "thunder-wave",
    "agility",
    "outrage",
    "safeguard",
    "twister",
    "rain-dance",
    "extreme-speed",
    "dragon-dance",
    "roost",
    "aqua-tail",
    "dragon-rush",
    "aqua-jet",
    "dragon-tail",
    "hurricane"
  ],
  "moves": [
    "fire-punch",
    "thunder-punch",
    "leer",
    "outrage",
    "rain-dance",
    "dragon-dance",
    "roost",
    "aqua-tail",
    "dragon-rush",
    "aqua-jet",
    "hurricane",
    "gust",
    "draco-meteor"
  ],
  "evolution_chain": {
    "id": 76,
    "item": null,
    "species": [
      {
        "name": "dratini",
        "order": 179,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dragonair",
        "order": 180,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 147,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dragonite",
        "order": 181,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 148,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 55,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
